import React from 'react';
import { COLORS } from '../../../styles/tokens';
import HalfHourTimeSelect from './HalfHourTimeSelect';
import SwitchRow from './SwitchRow';
import FixedPriceCard from './FixedPriceCard';
import { hourlyTotal } from '../../../utils/orderHourly';

const fmtKr = n => Number(n).toLocaleString('nb-NO');

// Pris og tid: leveringstidspunkt, prismodell som brytere (Fastpris / Forseglet anbud — alltid én på),
// fastprisfelt med prisforslag og «godta automatisk»-valg, eller anbudsfrist.
export default function PriceStep({
  scheduledAt, onScheduledAtChange,
  priceMode, onPriceModeChange,
  fixedPrice, onFixedPriceChange, priceHint, canRestorePrice, onRestorePrice,
  autoAccept, onAutoAcceptChange, allowBids, onAllowBidsChange, canAutoAccept,
  bidDeadline, onBidDeadlineChange,
  hourly = null,
  now,
}) {
  const fixed = priceMode === 'fixed';
  // Timeoppdrag ({ hours }): fastprisfeltet er timeprisen, og totalen vises under
  const total = hourly ? hourlyTotal(hourly.hours, fixedPrice) : null;

  // Gjensidig utelukkende: å slå på den ene slår av den andre. Den som er på kan ikke slås av.
  const setFixed = on => { if (on && !fixed) onPriceModeChange('fixed'); };
  const setBid = on => { if (on && fixed) onPriceModeChange('bid'); };

  function toggleAutoAccept(on) {
    onAutoAcceptChange(on);
    if (!on && allowBids) onAllowBidsChange(false);
  }

  return (
    <>
      <HalfHourTimeSelect label="Ønsket levering" icon="calendar" value={scheduledAt} onChange={onScheduledAtChange} now={now} />

      <div style={styles.list}>
        <SwitchRow
          title="Fastpris"
          sub="Du setter prisen og velger blant sjåførene som godtar"
          checked={fixed}
          onChange={setFixed}
        />
        <div style={styles.divider} />
        <SwitchRow
          title="Forseglet anbud"
          sub="Sjåfører byr, du velger vinner"
          checked={!fixed}
          onChange={setBid}
        />
      </div>

      {fixed && (
        <>
          <FixedPriceCard
            value={fixedPrice}
            onChange={onFixedPriceChange}
            hint={priceHint}
            canRestore={canRestorePrice}
            onRestore={onRestorePrice}
            label={hourly ? 'Timepris' : undefined}
            unitSuffix={hourly ? 'kr/time' : null}
          />
          {hourly && total != null && (
            <div data-testid="hourly-total" style={styles.total}>
              {`${hourly.hours} ${hourly.hours === 1 ? 'time' : 'timer'} × ${fmtKr(fixedPrice)} kr = ${fmtKr(total)} kr`}
            </div>
          )}
          {canAutoAccept && (
            <div style={styles.list}>
              <SwitchRow
                title="Godta første sjåfør automatisk"
                sub="Godkjente sjåfører får oppdraget med en gang til fastprisen."
                checked={autoAccept}
                onChange={toggleAutoAccept}
              />
              {autoAccept && (
                <>
                  <div style={styles.divider} />
                  <SwitchRow
                    title="Tillat bud under fastprisen"
                    sub="Fastprisen er det mest du betaler. Sjåfører kan også by lavere, og du velger blant budene. Den første som godtar fastprisen får fortsatt oppdraget."
                    checked={allowBids}
                    onChange={onAllowBidsChange}
                  />
                </>
              )}
            </div>
          )}
        </>
      )}

      {!fixed && (
        <>
          <HalfHourTimeSelect label="Anbudsfrist" icon="clock" value={bidDeadline} onChange={onBidDeadlineChange} now={now} />
          <div style={styles.note}>
            Sjåfører byr i det skjulte. Du ser alle bud etter fristen og velger vinner.
          </div>
        </>
      )}
    </>
  );
}

const styles = {
  list: { background: COLORS.white, border: `1px solid ${COLORS.border}`, borderRadius: 16, padding: '2px 14px' },
  divider: { height: 1, background: COLORS.border },
  total: { fontSize: 13.5, fontWeight: 600, color: COLORS.textDark, margin: '-4px 2px 0', lineHeight: 1.4 },
  note: { fontSize: 12.5, color: COLORS.textMid, margin: '-2px 0 0', lineHeight: 1.4 },
};
